import { apiClient } from '../api.client';
import type {
  BillingDetails,
  CheckoutSessionResult,
  IOrderService,
} from '../interfaces/IOrderService';

export const orderReal: IOrderService = {
  createCheckoutSession: (courseIds: string[], billing: BillingDetails) =>
    apiClient.post<{ clientSecret: string }>('/checkout/session', {
      courseIds,
      billing,
    }),

  getCheckoutSession: (sessionId: string) =>
    apiClient.get<CheckoutSessionResult>(`/checkout/session/${sessionId}`),
};
